// extracted by css-extract-rspack-plugin
export default {"item":"_f5f2a151"};